module.exports = __webpack_public_path__ + "static/media/book3.56c77709.jpg";